import React, {Component} from 'react';

class NoMatch extends Component {


  render() {

    return (
      <div>
        <h4>404 - INVALID URL</h4>
      </div>
    );
  }
}

export default NoMatch;



/** WEBPACK FOOTER **
 ** ./src/NoMatch.js
 **/